// extracted by mini-css-extract-plugin
export default {"navItem":"NavItem_navItem__RofrH","isActive":"NavItem_isActive__oaH-A","badge":"NavItem_badge__bUPTP","badgeValue":"NavItem_badgeValue__mS1g+","badgeDot":"NavItem_badgeDot__msiJt"};